import React, { useState } from 'react';
import { Modal, Button } from '../ui-kit';
import { IconEye } from '../ui-kit/icons';
import TemplatePatternDetails from '../schedule/TemplatePatternDetails';

const TemplatePatternDetailsPopover = ({ pattern, expand }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  return (
    <React.Fragment>
      <Button
        variant="info"
        size="md"
        onClick={handleShow}
        title={I18n.t('schedules.standby_duty_template_patterns.details')}
      >
        <IconEye />
      </Button>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{pattern.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TemplatePatternDetails pattern={pattern} expand={expand} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default TemplatePatternDetailsPopover;
